import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';

export default function ProtectedRoute({ children, requiredRole }) {
    const { user, loading, hasRole } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="loading"><div className="spinner" />Loading...</div>;
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requiredRole && !hasRole(requiredRole)) {
        return (
            <div className="loading" style={{ textAlign: 'center', padding: '4rem' }}>
                <h2 style={{ color: 'var(--error)' }}>Access Denied</h2>
                <p style={{ color: 'var(--text-secondary)' }}>
                    You need <strong>{requiredRole}</strong> role or higher to access this page.
                </p>
                <p style={{ color: 'var(--text-secondary)' }}>Your role: <strong>{user.role}</strong></p>
            </div>
        );
    }

    return children;
}